import { apiManagerRequest } from '../../axios';
import SurveyHomeService, { DEFAULT_SPECIALITY_NUMBER } from '../../services/Qualtrics/Home';
import Dates from '../../utils/dates';
import Session from '../../utils/session';
import { STATUS_CODE } from '../../utils/utils';
import { urlProvidersBase, presmedSolrAttentionPlaces } from '../urls';

const getDataFromSolrAction = async () => {
  const auth = Session.getAuth();
  try {
    const bodyRequest = {
      query: `wt=json&indent=true&fl=*&q=prestad:*&fq=prestad:${auth?.id}&group=true&group.field=nroespe&group.main=true&rows=999&sort=nroespe+asc`,
    };
    const { status, data } = await apiManagerRequest.post(presmedSolrAttentionPlaces, bodyRequest);

    if (status === STATUS_CODE.HTTP_200_OK) {
      return SurveyHomeService.getSpecialityNumberAndOwnCentreFromResponse(data.response);
    }
  } catch (error) {
    return [
      {
        id: 0,
        specialityNumber: DEFAULT_SPECIALITY_NUMBER,
        ownCentre: false,
      },
    ];
  }
};

const getAddresses = async () => {
  const auth = Session.getAuth();
  const fecha = Dates.get().toFormat('YYYYMMDD');
  const url = `${urlProvidersBase}/${auth.id}/lugaresDeAtencion?fecha=${fecha}`;

  try {
    const { status, data } = await apiManagerRequest.get(url);
    if (status === STATUS_CODE.HTTP_200_OK) {
      return SurveyHomeService.getAddressData(data);
    }
  } catch (error) {
    return null;
  }
};

export const getDataToUrlFromExternals = async () => {
  return Promise.all([getDataFromSolrAction(), getAddresses()])
    .then((response) => {
      const formattedResponse = {
        specialities: response[0],
        addresses: response[1],
      };
      return formattedResponse;
    })
    .catch((error) => {
      console.log('[ERROR]: ', error);
    });
};
